export default "__VITE_ASSET__CpMvdmDn__"